import React from "react";
import AppRoutes from "./routes/AppRoutes";
import "./index.css";

const App: React.FC = () => {
  return <AppRoutes />;
};

export default App;
